import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '@labshare/ngx-core-services';
import * as settings from 'projects/ngx-asr-lib/src/lib/settings/settings.json';
import {UsersService} from 'projects/ngx-asr-lib/src/lib/services/users.service';
import {Subscription} from 'rxjs';
import {AsrRoutePath} from 'projects/ngx-asr-lib/src/lib/constants';
import {Router} from '@angular/router';
import {GenericService} from 'projects/ngx-asr-lib/src/lib/services/generic.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './asr-user-profile.component.html',
  styleUrls: ['./asr-user-profile.component.scss']
})
export class AsrUserProfileComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  userProfileData;
  userRolesDisplay = '';
  admin = false;

  constructor(
    private authService: AuthService,
    private userService: UsersService,
    protected router: Router,
    private genericService: GenericService
  ) {}

  ngOnInit(): void {
    this.getUserProfile();
  }

  public getUserProfile(): void {
    this.userService.findCurrentUser().subscribe(data => {
      // Rewrite SharePoint profile URL before binding so the header <img> never
      // requests nih.sharepoint.com/staff-img.png on localhost.
      if (this.genericService.isLocalHost()) {
        data.profileImagePath = 'assets/staff-img.png';
      }
      this.userProfileData = data;
      this.userRolesDisplay = Array.isArray(data?.asrRoles) ? data.asrRoles.filter(Boolean).join(', ') : '';
      window.sessionStorage.setItem(settings.codes.sessionStorage.currentUser, JSON.stringify(data));
      if (this.genericService.isLocalHost()) {
        window.sessionStorage.setItem(settings.codes.sessionStorage.userPicture, this.userProfileData.profileImagePath);
      } else if (this.userProfileData.profileImagePath) {
        this.genericService.fetchAndProcessFile(this.userProfileData.profileImagePath).subscribe({
          next: (url: string) => {
            this.userProfileData.profileImagePath = url;
            window.sessionStorage.setItem(
              settings.codes.sessionStorage.userPicture,
              this.userProfileData.profileImagePath
            );
          },
          error: err => {
            console.error('Error fetching and processing file:', err);
          }
        });
      }
      const user = {email: this.userProfileData.email};
      const userIs = this.userProfileData.userIs?.admin;
      if (userIs === true) {
        this.admin = true;
      }
      this.userService.authorizeUser(user).subscribe();
    });
  }

  signOut() {
    this.userService.clearCurrentUserCache();
    this.userService.clearUsersByRoleCache();
    this.authService.logout();
  }

  manageUsers() {
    this.router.navigate([[AsrRoutePath.ASR_URL, AsrRoutePath.USER_DASHBOARD_URL].join('/')]);
  }

  surveySettings() {
    this.router.navigate([[AsrRoutePath.ASR_URL, AsrRoutePath.SURVEY_SETTINGS_DASHBOARD_URL].join('/')]);
  }

  leadSurveyUsers() {
    this.router.navigate([[AsrRoutePath.ASR_URL, AsrRoutePath.SURVEY_USERS_DASHBOARD_URL].join('/')]);
  }

  profileSettings() {
    const url = AsrRoutePath.PROFILE_SETTINGS_URL;
    window.open(url, '_blank');
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
